<template>
  <div class="tool-bar">
    <div>
      <a-dropdown-button type="primary"
                         :trigger="['click']"
                         v-if="showAdd && toolsArr.length"
                         @click="handleButtonClick">
        <a-icon type="plus" /> {{addText}}
        <a-menu slot="overlay"
                @click="handleMenuClick">
          <a-menu-item v-for="item in toolsArr"
                       :key="item.key">
            <span v-if="!item.imp">{{item.label}}</span>
            <a-upload v-else
                      name="file"
                      :multiple="false"
                      :action="url"
                      :headers="headers"
                      :beforeUpload="beforeUpload"
                      @change="handleChange"
                      :showUploadList="false">
              <span>{{item.label}}</span>
            </a-upload>
          </a-menu-item>
        </a-menu>
        <a-icon slot="icon"
                type="down" />
      </a-dropdown-button>
      <a-button type="primary" v-if="showAdd && !toolsArr.length" @click="handleButtonClick">
        <a-icon type="plus" /> {{addText}} 
      </a-button>
      <span @click="expand"
            v-if="showChildren"
            class="m-left text"
            type="text">
        {{showChildrenText ? '展开' : '折叠'}}
        <a-icon v-if="!showChildrenText"
                type="minus" />
        <a-icon v-else
                type="plus" />
      </span>
      <a-button class="m-left"
                v-if="showExp"
                @click="handleExport">
        {{expText}}
      </a-button>
    </div>
    <div class="left">
      <a-input ref="userNameInput"
               v-model="searchText"
               @pressEnter="toSearch"
               :placeholder="placeholder">
        <a-icon slot="prefix"
                type="search" />
      </a-input>
      <a-dropdown class="drop-left"
                  :trigger="['click']"
                  v-if="isShow">
        <a-icon class="icon"
                type="setting" />
        <a-menu class="drop-menu"
                slot="overlay">
          <a-menu-item v-for="(item, index) in searchArr"
                       :key="item.key">
            <a-checkbox @change="e => onChange(e.target.checked, index)"
                        :checked="item.isShow">{{item.title}}</a-checkbox>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import { getStorage } from '@/utils/index'
export default {
  props: {
    searchTips: {
      type: String,
      default: '输入ID、名称或角色搜索'
    },
    showAdd: {
      default: true
    },
    showExp: {
      default: false
    },
    expText: {
      default: '批量导出'
    },
    addText: {
      type: String,
      default: '新增'
    },
    toolsArr: {
      type: Array,
      default: () => []
    },
    searchArr: {
      type: Array,
      default: () => []
    },
    url: {
      type: String,
      default: ''
    },
    type: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: '请输入要搜索的字段'
    },
    isShow: {
      type: Boolean,
      default: true
    }, //右边控制表格字段下拉框
    showChildren: {
      type: Boolean,
      default: false
    },
    showChildrenText: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  data: () => ({
    visible: false,
    searchText: '',
    checked: [],
    headers: {}
  }),
  mounted() {
    const token = `${getStorage('token', 0)}`
    this.headers = {
      Authorization: token
    }
  },
  methods: {
    handleMenuClick(v) {
      this.$emit('dropMenuClick', v.key)
    },
    handleButtonClick() {
      this.$emit('add')
    },
    //check box
    onChange(v, i) {
      this.$emit('filter', { v, i })
    },
    toSearch() {
      this.$emit('search', this.searchText)
    },
    handleExport() {
      this.$emit('export')
    },
    expand() {
      this.$emit('expand')
    },
    beforeUpload(file) {
      const { name } = file
      const type = name.split('.').slice(-1)[0]
      if (this.type.indexOf(type) === -1) {
        this.$apiStatusHandler(99, '上传的附件类型不符合要求')
        return Promise.reject()
      }
    },
    handleChange(e) {
      if (e.file.status === 'done') {
        //const { code, msg, data } = e.file.response
        this.$emit('upload', e.file.response)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.m-left {
  margin-left: 10px;
  width: 180 !important;
}
.text {
  color: #aaaaaa;
  cursor: pointer;
}
.left {
  display: flex;
  justify-content: center;
  align-items: center;
  .icon {
    width: 80px;
    font-size: 20px;
    height: 45px;
    line-height: 50px;
    cursor: pointer;
  }
}
.drop-menu {
  width: 150px !important;
  .ant-dropdown-menu {
    width: 150px;
    margin-left: 10px;
  }
}
.a-checkbox {
  margin-left: 10px;
}
</style>